export default class OrderService {
  constructor($http) {
    this.$http = $http;
  }
  
  update_website_stats() {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/orders/update_website_stats',
      data: {authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  save(order) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/orders/save',
      data: {order: order, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_manage_data(filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/orders/get_manage_data',
      data: {filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_arrivals_data(filter) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/orders/get_arrivals_data',
      data: {filter: filter, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update_supplier_user_products(order_id, user_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/orders/update_supplier_user_products',
      data: {id: order_id, user_id: user_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update_buyer_user_products(order_id, user_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/orders/update_buyer_user_products',
      data: {id: order_id, user_id: user_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update_supplier_pricings(order_id) {
    return this.$http.post(
      '/admin/marketplace/orders/update_supplier_pricings',
      {order_id: order_id, authenticity_token: window.token}
    );
  }

  get_attachments(order_id, doc_types) {
    return this.$http.post(
      '/admin/marketplace/orders/get_order_attachments/',
      {order_id: order_id, doc_types: doc_types, authenticity_token: window.token}
    );
  }

  send_notification(order_id, custom_title, custom_text, attachments, contacts, sender_name_en, sender_name_el, test_send, test_send_email) {
    return this.$http.post(
      '/admin/marketplace/orders/send_notification',
      {order_id: order_id, custom_title: custom_title, custom_text: custom_text, attachments: attachments, contacts: contacts, sender_name_en: sender_name_en, sender_name_el: sender_name_el, test_send: test_send, test_send_email: test_send_email, authenticity_token: window.token}
    );
  }

  get_notifications(order_id) {
    return this.$http.get('/admin/marketplace/orders/get_order_notifications/' + order_id);
  }

  delete_attachment(attachment_id) {
    return this.$http.post(
      '/admin/marketplace/orders/delete_order_attachment',
      {attachment_id: attachment_id, authenticity_token: window.token}
    );
  }

  resend_notification(notification_id) {
    return this.$http.post(
      '/admin/marketplace/orders/resend_notification',
      {notification_id: notification_id, authenticity_token: window.token}
    );
  }
}

OrderService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/order.service.js